<template>
  <div>
    <vessel-trial-test-details
      :vessel-trial-test="vesselTrialTest"
    ></vessel-trial-test-details>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import ObjectType from '@/services/Objects.js'
import VesselTrialTestDetails from '@/components/VesselTrialTestDetails.vue'

export default {
  name: 'VesselTrialTest',
  components: {
    VesselTrialTestDetails
  },
  props: {
    id: String
  },
  data() {
    return {
      vesselTrialTest: {}
    }
  },
  created() {
    this.getTrialTest()
  },
  methods: {
    getTrialTest() {
      ApiService.get(ObjectType.VesselTrialTest, this.id).then(response => {
        this.vesselTrialTest = response.data
      })
    }
  }
}
</script>

<style scoped></style>
